import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faEye,
  faEyeSlash,
  faRandom,
  faCog,
  faTable,
  faFont,
  faCopy,
  faQuestionCircle,
  faTrash,
  faCut,
  faUpload,
  faDollarSign,
  faCalendar,
  faChevronUp,
  faChevronDown,
  faChevronRight,
  faAngleLeft,
  faCheck,
  faCheckCircle,
  faDownload,
  faSearch,
  faTimes,
  faTimesCircle,
  faShareAlt,
  faUndo,
  faPlay,
  faShare,
  faCrop,
  faExpand,
  faExclamationTriangle,
  faMousePointer,
  faArrowsAlt,
  faSearchPlus,
  faSearchMinus,
  faPencilAlt,
  faForward,
  faPlus,
  faMinus,
  faExternalLinkAlt,
  faPercentage,
  faUniversity,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileContract,
  faFileAlt,
  faFile,
  faHashtag,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faExclamationCircle,
  faFileExcel,
  faFileCsv,
  faEdit,
  faComments,
  faSignOutAlt,
  faUserCircle,
  faRedo,
  faSyncAlt,
  faSync,
  faGift,
  faStar,
  faFileExport,
  faEnvelope,
  faInfoCircle,
  faFrown,
  faHeart,
  faUserPlus,
  faHandshake,
  faHandPointer,
  faLock,
  faToggleOn,
  faToggleOff,
  faPlusCircle,
  faHistory,
  faCheckSquare,
  faChartLine,
  faClock,
  faSave,
  faShieldAlt,
  faCalculator,
  faCloudUploadAlt,
  faFolderOpen,
  faFilePdf,
  faGlobe,
  faPiggyBank,
  faRocket,
  faPlayCircle,
  faCalendarAlt,
  faVideo,
  faPhone,
  faPaperPlane,
  faCalendarCheck,
  faUsers,
  faMagic,
  faChevronLeft,
  faLightbulb,
  faUserCheck,
  faBuilding,
  faBriefcase,
  faChartPie,
  faThumbsUp,
  faThumbsDown,
  faAward,
  faFlag,
  faLink,
  faFolder,
  faUser,
  faUserCog,
  faUserShield,
  faUserSlash,
  faUserMinus,
  faSpinner,
  faMobileAlt,
  faQrcode,
  faRobot,
  faCheckDouble,
  faTag,
  faCube,
  faEllipsisV,
  faTasks,
  faUnlink,
  faBolt,
  faStream,
} from "@fortawesome/free-solid-svg-icons";

import {
  faGoogle,
  faGoogleDrive,
  faMicrosoft,
  faApple,
  faGooglePlay,
  faDropbox,
} from "@fortawesome/free-brands-svg-icons";
import { faCircle, faSquare } from "@fortawesome/free-regular-svg-icons";

export const initIcons = () => {
  library.add(
    ...([
    faEye,
    faEyeSlash,
    faRandom,
    faCog,
    faTable,
    faFont,
    faCopy,
    faQuestionCircle,
    faTrash,
    faCut,
    faUpload,
    faDollarSign,
    faCalendar,
    faChevronUp,
    faChevronDown,
    faChevronRight,
    faAngleLeft,
    faCheck,
    faCheckCircle,
    faDownload,
    faSearch,
    faTimes,
    faTimesCircle,
    faShareAlt,
    faUndo,
    faPlay,
    faShare,
    faCrop,
    faExpand,
    faExclamationTriangle,
    faMousePointer,
    faArrowsAlt,
    faSearchPlus,
    faSearchMinus,
    faPencilAlt,
    faForward,
    faPlus,
    faMinus,
    faExternalLinkAlt,
    faPercentage,
    faUniversity,
    faHashtag,
    faArrowUp,
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faExclamationCircle,
    faFileExcel,
    faFileCsv,
    faGoogle,
    faGoogleDrive,
    faMicrosoft,
    faEdit,
    faComments,
    faSignOutAlt,
    faUserCircle,
    faRedo,
    faSyncAlt,
    faSync,
    faGift,
    faStar,
    faFileExport,
    faEnvelope,
    faInfoCircle,
    faFrown,
    faHeart,
    faUserPlus,
    faHandshake,
    faHandPointer,
    faLock,
    faCircle,
    faSquare,
    faToggleOn,
    faToggleOff,
    faPlusCircle,
    faHistory,
    faCheckSquare,
    faFileInvoice,
    faFileInvoiceDollar,
    faFileContract,
    faFileAlt,
    faFile,
    faChartLine,
    faClock,
    faSave,
    faShieldAlt,
    faCalculator,
    faCloudUploadAlt,
    faFolderOpen,
    faFilePdf,
    faGlobe,
    faPiggyBank,
    faRocket,
    faPlayCircle,
    faCalendarAlt,
    faVideo,
    faPhone,
    faPaperPlane,
    faCalendarCheck,
    faUsers,
    faMagic,
    faChevronLeft,
    faLightbulb,
    faUserCheck,
    faBuilding,
    faBriefcase,
    faChartPie,
    faThumbsUp,
    faThumbsDown,
    faAward,
    faFlag,
    faLink,
    faFolder,
    faUser,
    faUserCog,
    faUserShield,
    faUserSlash,
    faUserMinus,
    faSpinner,
    faMobileAlt,
    faQrcode,
    faApple,
    faGooglePlay,
    faRobot,
    faCheckDouble,
    faTag,
    faCube,
    faEllipsisV,
    faDropbox,
    faTasks,
    faUnlink,
    faBolt,
    faStream,
  ] as any));
};

// export const setupGA = () => {
//   const accountId =
//     process.env.NODE_ENV === "production" ? "UA-132343690-1" : "UA-132343690-2";

//   GoogleAnalytics.initialize(accountId, { debug: false });
//   GoogleAnalytics.plugin.require("linkid");
//   GoogleAnalytics.set(getFields());
// };
